import React from 'react'

interface ShimmerEffectProps {
  className?: string
  children?: React.ReactNode
}

export default function ShimmerEffect({ className = '', children }: ShimmerEffectProps) {
  return (
    <div className={`animate-pulse ${className}`}>
      {children}
    </div>
  )
}

// Shimmer skeleton components for different UI elements
export function ShimmerCard({ className = '' }: { className?: string }) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-4 sm:p-6 ${className}`}>
      <div className="flex items-center space-x-2 sm:space-x-3 mb-4 sm:mb-6">
        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded-lg"></div>
        <div className="flex-1">
          <div className="h-4 sm:h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
      <div className="space-y-4 sm:space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <div>
            <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
            <div className="h-10 sm:h-11 bg-gray-200 rounded"></div>
          </div>
          <div>
            <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
            <div className="h-10 sm:h-11 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div>
          <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-10 sm:h-11 bg-gray-200 rounded"></div>
        </div>
        <div className="grid grid-cols-3 gap-2 sm:gap-4">
          <div>
            <div className="h-3 bg-gray-200 rounded w-1/2 mb-1"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
          </div>
          <div>
            <div className="h-3 bg-gray-200 rounded w-1/2 mb-1"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
          </div>
          <div>
            <div className="h-3 bg-gray-200 rounded w-1/2 mb-1"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function ShimmerProgressBar({ className = '' }: { className?: string }) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-4 sm:p-6 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="h-4 sm:h-5 bg-gray-200 rounded w-1/4"></div>
        <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/6"></div>
      </div>
      <div className="space-y-2 sm:space-y-3">
        <div className="h-2 sm:h-3 bg-gray-200 rounded-full"></div>
        <div className="flex justify-between">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex flex-col items-center space-y-1 sm:space-y-2">
              <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gray-200 rounded-full"></div>
              <div className="h-3 bg-gray-200 rounded w-12 sm:w-16"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export function ShimmerNavigation({ className = '' }: { className?: string }) {
  return (
    <div className={`flex flex-col sm:flex-row justify-between gap-3 sm:gap-0 ${className}`}>
      <div className="h-10 sm:h-11 bg-gray-200 rounded w-full sm:w-24"></div>
      <div className="h-10 sm:h-11 bg-gray-200 rounded w-full sm:w-24"></div>
    </div>
  )
}
